export const TERMS_OF_SERVICE_URL = 'https://club-os.com/terms';
export const PRIVACY_POLICY_URL = 'https://club-os.com/privacy';

export const RETURN_URL_PARAM = 'returnUrl';

export const BATCH_SCHEDULE_DAYS = 7;
export const DEFAULT_EVENT_TYPES = [2, 3, 7];
